import { Table, TableContainer, TextField } from "@mui/material";
import useTable from "src/hooks/useTable";
import { useGetUnknownTransactions } from "src/services/admin/queries/unknownTransactions";

import ContextTable from "./contextTable";
import SkeletonTable from "./SkeletonTable";
import TableBody from "./TableBody";
import TableFilterEntity from "./TableFilterEntity";
import TableHeader from "./TableHeader";
import TableNotFound from "./TableNotFound";
import TablePagination from "./TablePagination";
import TableSelectedHeader from "./TableSelectedHeader";
import useFilterTransactionsByEntities from "./useFilterTransactionsByEntities";

// ----------------------------------------------------------------------

export const UnknownTransactionsTable = () => {
	const { data, isLoading, isError } = useGetUnknownTransactions();
	const { filtersSelected, onSelectFilter, entities, filterName, onFilterName } =
		useFilterTransactionsByEntities(data?.map((item) => item.entity) ?? []);

	const empty = data?.length === 0 || isError;

	const control = useTable({
		defaultOrderBy: "createdAt",
		defaultRowsPerPage: 12,
		defaultDense: true
	});

	const filterData = (data ?? []).filter(
		(item) =>
			(filtersSelected.length === 0 || filtersSelected.includes(item.entity)) &&
			item.description.toLowerCase().includes(filterName.toLowerCase())
	);

	return (
		<ContextTable.Provider value={{ ...control }}>
			<TableContainer>
				{isLoading && <SkeletonTable />}
				<TextField
					size='small'
					label='Buscar por descripción'
					value={filterName}
					onChange={(e) => onFilterName(e.target.value)}
					sx={{ mb: 3, ml: 3, minWidth: 300 }}
				/>
				<TableFilterEntity
					filtersSelected={filtersSelected}
					onSelectFilter={onSelectFilter}
					entities={entities}
				/>

				{!isLoading && <TableSelectedHeader data={filterData ?? []} />}
				{!isLoading && filterData && (
					<Table size='small'>
						<TableHeader data={filterData} />
						<TableBody data={filterData} />
						{empty && <TableNotFound />}
					</Table>
				)}
			</TableContainer>
			{!empty && <TablePagination count={filterData?.length ?? 0} />}
		</ContextTable.Provider>
	);
};

export default UnknownTransactionsTable;
